// extracted by mini-css-extract-plugin
export default {"card":"style_card__QpBfv","selected":"style_selected__+yxQu","top":"style_top__PKj8D","icon":"style_icon__3u11N","name":"style_name__8LWP8"};